import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const campaignTableStateAtom = atom({
  key: RecoilAtomKey.campaignListKey,
  default: {
    cache: {},
    totalCountCache: {},
    filters: {
      to: 0,
      include_assigned_by: 0,
      fetch_all: 0,
      page: 0,
      next_page: 0,
      organisation_id: '',
      search:"",
      limit:10,
    },
    isLoading: false,
  },
});

const campaignDropdownStateAtom = atom({
  key: RecoilAtomKey.campaignDropdownStateKey,
  default: {
    cache: {},
    totalCountCache: {},
    filters: {
      next_page: 0,
      organisation_id: '',
      search:"",      
    },
    isLoading: false,
  },
});

export { campaignTableStateAtom ,campaignDropdownStateAtom};
